<template>
    <form-field v-bind="{ ...fieldProps, label: undefined }">
        <checkbox-input v-bind="inputProps" @change="change($event)" @emitEvent="emitEvent($event, ['change'])">
            <template #label>
                <slot name="label"></slot>
            </template>
        </checkbox-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'

    export default {
        mixins: [FormFieldMixin],

        props: {
            hasBigTapArea: { type: Boolean, default: false },
            direction: { type: String, default: null },
            checkedIcon: { type: String, default: null },
        },
    }
</script>
